import { __decorate, __param } from 'tslib';
import { InjectionToken, Optional, Inject, Injectable, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule } from '@angular/forms';
import { HttpClient, HttpHeaders, HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { RouterModule } from '@angular/router';
import { config as config$1, API_CONFIG, ApiModule } from '@ff/api';
import { UserService, UserModule } from '@ff/user';
import { BehaviorSubject } from 'rxjs';

import * as ɵngcc0 from '@angular/core';
import * as ɵngcc1 from '@ff/user';
import * as ɵngcc2 from '@angular/common/http';
const config = {
    host: config$1.host,
    username: 'email',
    endpoints: {
        login: '/auth/login',
        logout: '/auth/logout'
    }
};

const AUTH_CONFIG = new InjectionToken('auth.config');

// @dynamic
let AuthService = class AuthService {
    constructor(_apiConfig, _config, _userService, _httpClient) {
        this._apiConfig = _apiConfig;
        this._config = _config;
        this._userService = _userService;
        this._httpClient = _httpClient;
        this._config = Object.assign(config, this._config);
        this._apiConfig = Object.assign(config$1, this._apiConfig);
        this._isLoggedIn = new BehaviorSubject(false);
        // Subscribe to user object
        this._userService.getUser().subscribe((user) => {
            this._isLoggedIn.next(user != null);
        });
    }
    /**
     * Return observable
     */
    isLoggedIn() {
        return this._isLoggedIn;
    }
    /**
     * Attempt to login user then fetch user from remote server
     * Returns a Promise<any>
     * @param data
     */
    login(data) {
        const url = this._config.host + this._config.endpoints.login;
        return this._httpClient.post(url, data.value)
            .toPromise()
            .then(response => (response.data))
            .then(response => {
            if (response.token) {
                localStorage.setItem('_token', response.token);
            }
            return this._userService.fetch();
        });
    }
    /**
     * Attempt to logout user
     * Returns a Promise<any>
     */
    logout() {
        const url = this._config.host + this._config.endpoints.logout;
        this._userService.getUser().next(null);
        return this._httpClient.get(url)
            .toPromise()
            .then(() => {
            localStorage.removeItem('_token');
        });
    }
};
AuthService.ɵfac = function AuthService_Factory(t) { return new (t || AuthService)(ɵngcc0.ɵɵinject(API_CONFIG, 8), ɵngcc0.ɵɵinject(AUTH_CONFIG, 8), ɵngcc0.ɵɵinject(ɵngcc1.UserService), ɵngcc0.ɵɵinject(ɵngcc2.HttpClient)); };
AuthService.ɵprov = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjectable({ token: AuthService, factory: function (t) { return AuthService.ɵfac(t); } });
AuthService.ctorParameters = () => [
    { type: undefined, decorators: [{ type: Optional }, { type: Inject, args: [API_CONFIG,] }] },
    { type: undefined, decorators: [{ type: Optional }, { type: Inject, args: [AUTH_CONFIG,] }] },
    { type: UserService },
    { type: HttpClient }
];
AuthService = __decorate([ __param(0, Optional()), __param(0, Inject(API_CONFIG)),
    __param(1, Optional()), __param(1, Inject(AUTH_CONFIG))
], AuthService);

let BearerInjection = class BearerInjection {
    intercept(req, next) {
        const token = localStorage.getItem('_token');
        let headers = new HttpHeaders();
        if (req.headers) {
            headers = req.headers;
        }
        if (token) {
            headers = headers
                .set('Accept', `application/json`)
                .set('Authorization', `Bearer ${token}`);
        }
        const duplicate = req.clone({ headers: headers });
        return next.handle(duplicate);
    }
};
BearerInjection.ɵfac = function BearerInjection_Factory(t) { return new (t || BearerInjection)(); };
BearerInjection.ɵprov = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjectable({ token: BearerInjection, factory: function (t) { return BearerInjection.ɵfac(t); } });

let AuthModule = class AuthModule {
};
AuthModule.ɵfac = function AuthModule_Factory(t) { return new (t || AuthModule)(); };
AuthModule.ɵmod = /*@__PURE__*/ ɵngcc0.ɵɵdefineNgModule({ type: AuthModule });
AuthModule.ɵinj = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjector({ providers: [
        AuthService,
        {
            provide: HTTP_INTERCEPTORS, useClass: BearerInjection, multi: true
        },
    ], imports: [[
            CommonModule,
            ReactiveFormsModule,
            HttpClientModule,
            RouterModule,
            ApiModule,
            UserModule
        ]] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(AuthService, [{
        type: Injectable
    }], function () { return [{ type: undefined, decorators: [{
                type: Optional
            }, {
                type: Inject,
                args: [API_CONFIG]
            }] }, { type: undefined, decorators: [{
                type: Optional
            }, {
                type: Inject,
                args: [AUTH_CONFIG]
            }] }, { type: ɵngcc1.UserService }, { type: ɵngcc2.HttpClient }]; }, null); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(BearerInjection, [{
        type: Injectable
    }], null, null); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(AuthModule, [{
        type: NgModule,
        args: [{
                imports: [
                    CommonModule,
                    ReactiveFormsModule,
                    HttpClientModule,
                    RouterModule,
                    ApiModule,
                    UserModule
                ],
                providers: [
                    AuthService,
                    {
                        provide: HTTP_INTERCEPTORS, useClass: BearerInjection, multi: true
                    },
                ],
                exports: []
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(AuthModule, { imports: function () { return [CommonModule,
        ReactiveFormsModule,
        HttpClientModule,
        RouterModule,
        ApiModule,
        UserModule]; } }); })();

/**
 * Generated bundle index. Do not edit.
 */

export { AUTH_CONFIG, AuthModule, AuthService, BearerInjection };

